import React from 'react';

export const FlagCOIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 400" // Standard 3:2 ratio
    {...props}
  >
    <rect width="600" height="400" fill="#003893" rx="2"/> {/* Blue (bottom quarter) */}
    <rect width="600" height="300" fill="#CE1126" /> {/* Red (middle quarter) */}
    <rect width="600" height="200" fill="#FCD116" /> {/* Yellow (top half) */}
    <rect width="600" height="400" fill="none" stroke="#6b7280" strokeOpacity="0.3" strokeWidth="1" rx="2"/>
  </svg>
);